import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";

require('./site-provider-action-menu.scss');
@Component({
  standalone: false,
  selector: 'app-site-provider-action-menu',
  templateUrl: './site-provider-action-menu.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteProviderActionMenuComponent {

  /** Scopes the toggle's id, which the dropdown menu is labelled by - one row each. */
  @Input() providerId: string;

  @Output() onEdit = new EventEmitter<void>();
  @Output() onArchive = new EventEmitter<void>();

}
